import { render, staticRenderFns } from "./referralOrderList.vue?vue&type=template&id=94dcd8e6&scoped=true&"
import script from "./referralOrderList.vue?vue&type=script&lang=js&"
export * from "./referralOrderList.vue?vue&type=script&lang=js&"
import style0 from "./referralOrderList.vue?vue&type=style&index=0&id=94dcd8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94dcd8e6",
  null
  
)

export default component.exports